import React, { Component } from 'react';
import PropTypes from "prop-types";
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import Paper from '@material-ui/core/Paper';
import Select,{components} from 'react-select';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import CancelIcon from '@material-ui/icons/Cancel';

import { emphasize } from '@material-ui/core/styles/colorManipulator';


function NoOptionsMessage(props) {
	return (
		<Typography
			color="textSecondary"
			className={props.selectProps.classes.noOptionsMessage}
			{...props.innerProps}
		>
			対象データなし
		</Typography>
	);
}

function inputComponent({ inputRef, ...props }) {
	return <div ref={inputRef} {...props} />;
}

function Control(props) {
	return (
		<TextField
			fullWidth
			disabled={props.isDisabled}
			error={props.selectProps.error}
			InputProps={{
				inputComponent,
				inputProps: {
					className: props.selectProps.classes.input,
					inputRef: props.innerRef,
					children: props.children,
					...props.innerProps,
				},
			}}
			{...props.selectProps.textFieldProps}
		/>
	);
}

function Option(props) {
	return (
		<MenuItem
			buttonRef={props.innerRef}
			selected={props.isFocused}
			component="div"
			style={{
				fontWeight: props.isSelected ? 500 : 400,
			}}
			{...props.innerProps}
		>
			{props.children}
		</MenuItem>
	);
}

function Placeholder(props) {
	return (
		<Typography
			color="textSecondary"
			className={props.selectProps.classes.placeholder}
			{...props.innerProps}
		>
			{props.children}
		</Typography>
	);
}

function SingleValue(props) {
	const {children, selectProps,isDisabled, innerProps} = props;
	const {classes} = selectProps;
	return (
		<Typography className={classNames(classes.singleValue,(isDisabled) ? classes.disabledText : '')} {...innerProps}>
			{children}
		</Typography>
	);
}

function ValueContainer(props) {
	return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

function MultiValue(props) {
	return (
		<Chip
			tabIndex={-1}
			label={props.children}
			className={classNames(props.selectProps.classes.chip, {
				[props.selectProps.classes.chipFocused]: props.isFocused,
			})}
			onDelete={props.removeProps.onClick}
			deleteIcon={<CancelIcon {...props.removeProps} />}
		/>
	);
}

function Menu(props) {
	return (
		<Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
			{props.children}
		</Paper>
	);
}

function Input(props){
	const handleKeyPress = (event) =>{
		if(props.selectProps.InputProps.onKeyPress) props.selectProps.InputProps.onKeyPress(event);
	};
	return (
		<components.Input {...props}{...props.selectProps.InputProps} onKeyPress={handleKeyPress}/>
	);
}

const component = {
	Control,
	Menu,
	MultiValue,
	NoOptionsMessage,
	Option,
	Placeholder,
	SingleValue,
	ValueContainer,
	Input
};


const styles = theme => ({
	singInButton: {
		marginRight: theme.spacing.unit,
	},
	textField:{
		width:'100%',
		marginBottom:15
	},
	root: {
		flexGrow: 1,
		height: 250,
	},
	input: {
		display: 'flex',
		padding: 0,
	},
	valueContainer: {
		display: 'flex',
		flexWrap: 'wrap',
		flex: 1,
		alignItems: 'center',
		overflow: 'hidden',
	},
	chip: {
		margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
	},
	chipFocused: {
		backgroundColor: emphasize(
			theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
			0.08,
		),
	},
	noOptionsMessage: {
		padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
	},
	singleValue: {
		fontSize: 16,
		overflow:'hidden',
		textOverflow:'ellipsis',
		whiteSpace:'nowrap',
		maxWidth:'calc(100% - 10px)'
	},
	disabledText:{
		color:'rgba(0,0,0,0.38)'
	},
	placeholder: {
		position: 'absolute',
		left: 2,
		fontSize: 16,
	},
	paper: {
		position: 'absolute',
		zIndex: 902,
		marginTop: theme.spacing.unit,
		left: 0,
		right: 0,
	},
	divider: {
		height: theme.spacing.unit * 2,
	},
});


class ControlSuggestSelect extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value:props.value
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps){
		if(this.state.value !== nextProps.value){
			this.setState({
				value : nextProps.value
			});


		}
	}

	_handleChange = data =>{
		this.setState({
			value:data
		});
		if(this.props.afterChangeFunction) this.props.afterChangeFunction(data);

	};

	render() {
		const { classes,theme,inputLabel,maxLength,suggestions,fixValue,error,disabled,maxMenuHeight,isClearable} = this.props;

		const selectStyles = {
			input: base => ({
				...base,
				color: theme.palette.text.primary,
				'& input': {
					font: 'inherit',
				},
			}),
		};

		const value = (fixValue !== null) ? fixValue : this.state.value;
		const disable = disabled || (fixValue !== null);

		let InputLabelProps = {};
		if(value !== null){
			InputLabelProps = {shrink:true}
		}
		return (
			<Select
				classes={classes}
				styles={selectStyles}
				options={suggestions}
				components={component}
				value={value}
				onChange={this._handleChange}
				isDisabled={disable}
				textFieldProps={{
					label: inputLabel,
					InputLabelProps: InputLabelProps,
				}}
				error={error}
				InputProps={{
					maxLength: maxLength,
				}}
				placeholder={''}
				maxMenuHeight={maxMenuHeight}
				isClearable={isClearable}
			/>
		);
	}
}

ControlSuggestSelect.propTypes = {
	inputLabel:PropTypes.string,
	maxLength:PropTypes.number,
	suggestions:PropTypes.array,
	fixValue:PropTypes.object,
	value:PropTypes.object,
	afterChangeFunction:PropTypes.func,
	error:PropTypes.bool,
	disabled:PropTypes.bool,
	maxMenuHeight:PropTypes.number,
	isClearable:PropTypes.bool

};
ControlSuggestSelect.defaultProps = {
	inputLabel:'',
	suggestions:[],
	fixValue:null,
	defaultValue:null,
	maxLength:100,
	error:false,
	disabled:false,
	maxMenuHeight:300,
	isClearable:true,
};

export default withStyles(styles, { withTheme: true })(ControlSuggestSelect);



// WEBPACK FOOTER //
// ./src/common/components/input/control-suggest-select.js